import { makeStyles, Tooltip, MenuItem } from '@material-ui/core';
import styled from 'styled-components'
import Select from '@mui/material/Select';
import Colors from 'modules/Colors';
import { TargetingAudienceGroup } from './Types';

const Sty = {
    border: `1px solid ${Colors.greyLight}`,
    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
    boxShadowInset: 'inset 0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
    boxShadowTop: '0px -10px 10px 0px rgba(0, 0, 0, 0.1)',
    boxShadowBottom: '0px 10px 10px 0px rgba(0, 0, 0, 0.1)',
    boxShadowLeft: '10px 0px 10px 0px rgba(0, 0, 0, 0.1)',
    boxShadowRight: '-10px 0px 10px 0px rgba(0, 0, 0, 0.1)',

    text: {
        fontSize: 16,
        fontWeight: 400,
        color: Colors.black,
    },
    text12: {
        fontSize: 12,
        color: Colors.black,
        fontWeight: 400,
    },
    text14: {
        fontSize: 14,
        color: Colors.black,
        fontWeight: 400,
    },
    text16: {
        fontSize: 16,
        color: Colors.black,
        fontWeight: 400,
    },
    text18: {
        fontSize: 18,
        color: Colors.black,
        fontWeight: 400,
    },
    text20: {
        fontSize: 20,
        color: Colors.black,
        fontWeight: 400,
    },
    text24: {
        fontSize: 24,
        color: Colors.black,
        fontWeight: 400,
    },
    text32: {
        fontSize: 32,
        color: Colors.black,
        fontWeight: 400,
    },

    text12grey: {
        fontSize: 12,
        color: Colors.greyDark,
        fontWeight: 400,
    },
    text14grey: {
        fontSize: 14,
        color: Colors.greyDark,
        fontWeight: 400,
    },
    text16grey: {
        fontSize: 16,
        color: Colors.greyDark,
        fontWeight: 400,
    },
    text16greyBold: {
        fontSize: 16,
        color: Colors.greyDark,
        fontWeight: 500,
    },
    text18grey: {
        fontSize: 18,
        color: Colors.greyDark,
        fontWeight: 400,
    },
    text20grey: {
        fontSize: 20,
        fontWeight: 400,
        color: Colors.greyDark,
    },
    text24grey: {
        fontSize: 24,
        fontWeight: 400,
        color: Colors.greyDark,
    },

    text14purple: {
        fontSize: 14,
        fontWeight: 400,
        color: Colors.purple,
    },
    text16purple: {
        fontSize: 16,
        fontWeight: 400,
        color: Colors.purple,
    },
    text16purpleBold: {
        fontSize: 16,
        fontWeight: 500,
        color: Colors.purple,
    },
    text20purple: {
        fontSize: 20,
        fontWeight: 400,
        color: Colors.purple,
    },

    text12white: {
        fontSize: 12,
        fontWeight: 400,
        color: Colors.white,
    },
    text14white: {
        fontSize: 14,
        fontWeight: 400,
        color: Colors.white,
    },
    text16white: {
        fontSize: 16,
        fontWeight: 400,
        color: Colors.white,
    },
    text24white: {
        fontSize: 24,
        fontWeight: 400,
        color: Colors.white,
    },
    text16whiteBold: {
        fontSize: 16,
        fontWeight: 500,
        color: Colors.white,
        transform: `translateY(2px)`
    },
    text24whiteBold: {
        fontSize: 24,
        fontWeight: 500,
        color: Colors.white,
        transform: `translateY(2px)`
    },

    text12bold: {
        fontSize: 12,
        fontWeight: 500,
        color: Colors.black,
        transform: `translateY(2px)`
    },
    text14bold: {
        fontSize: 14,
        fontWeight: 500,
        color: Colors.black,
        transform: `translateY(2px)`
    },
    text16bold: {
        fontSize: 16,
        fontWeight: 500,
        color: Colors.black,
        transform: `translateY(2px)`
    },
    text18bold: {
        fontSize: 18,
        fontWeight: 500,
        color: Colors.black,
        transform: `translateY(2px)`
    },
    text20bold: {
        fontSize: 20,
        fontWeight: 600,
        color: Colors.black,
    },
    text24bold: {
        fontSize: 24,
        fontWeight: 600,
        color: Colors.black,
    },


    input: { // NOTE: this is deprecated, use InputSymphony instead
        padding: "12px 16px",
        width: "100%",
        fontSize: 16,
        fontWeight: 400,
        color: Colors.black,
        borderRadius: 6,
        border: "1px solid #EDECF2",
        outline: "none",
    },
}

export interface StyledLabelProps {
    fontSize?: number;
    fontWeight?: number;
    color?: string;
    cursor?: string;
    margin?: string;
    padding?: string;
    paddingLeft?: string;
    marginTop?: string;
    paddingBottom?: string;
    alignText?: string;
    width?: string;
    marginRight?: string;
    borderBottomWidth?: string;
    fontFamily?: string;
    textAlign?: string;
    overflowWrap?: string;
    whiteSpace?: string;
    paddingTop?: string;
}

export const StyledLabelP = styled.div`
  font-weight: ${({ fontWeight }: StyledLabelProps) => fontWeight || 400};
  font-size: ${({ fontSize }: StyledLabelProps) => fontSize || 18}px;
  color: ${({ color }: StyledLabelProps) => color};
  cursor: ${({ cursor }: StyledLabelProps) => cursor};
  margin-top: ${({ marginTop }: StyledLabelProps) => marginTop};
  padding-bottom: ${({ paddingBottom }: StyledLabelProps) => paddingBottom};
  align-text: ${({ alignText }: StyledLabelProps) => alignText};
  margin: ${({ margin }: StyledLabelProps) => margin || "0px"};
  width: ${({ width }: StyledLabelProps) => width};
  margin-right: ${({ marginRight }: StyledLabelProps) => marginRight};
  border-bottom-width: ${({ borderBottomWidth }: StyledLabelProps) => borderBottomWidth};
  font-family: ${({ fontFamily }: StyledLabelProps) => fontFamily};
  text-align: ${({ textAlign }: StyledLabelProps) => textAlign};
  overflow-wrap: ${({ overflowWrap }: StyledLabelProps) => overflowWrap};
  white-space: ${({ whiteSpace }: StyledLabelProps) => whiteSpace};
  padding-top: ${({ paddingTop }: StyledLabelProps) => paddingTop};
`;

export interface StyledLabelProps {
    fontSize?: number
    fontWeight?: number
    color?: string
    cursor?: string
    margin?: string
    padding?: string
    paddingLeft?: string
    marginLeft?: string
    fontFamily?: string
}

export const StyledLabelSpan = styled.span`
  font-weight: ${({ fontWeight }: StyledLabelProps) => fontWeight || 400};
  font-size: ${({ fontSize }: StyledLabelProps) => fontSize || 12}px;
  color: ${({ color }: StyledLabelProps) => color};
  cursor: ${({ cursor }: StyledLabelProps) => cursor};
  margin: ${({ margin }: StyledLabelProps) => margin};
  padding: ${({ padding }: StyledLabelProps) => padding};
  padding-left: ${({ paddingLeft }: StyledLabelProps) => paddingLeft};
  margin-left: ${({ marginLeft }: StyledLabelProps) => marginLeft};
  font-family: ${({ fontFamily }: StyledLabelProps) => fontFamily};
`;

export interface CardProps {
    borderRadius?: string
    showBorder?: boolean
}

export const Card = styled.div`
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom-width: 1px;
    border-color: rgba(229, 231, 235, 1);
    width: 100%;
    background-color: white;
    border-radius: ${({ borderRadius, showBorder }: CardProps) => borderRadius || (showBorder ? '12px' : '0px')};
    @media (min-width: 1024px) {
        padding-left: 40px;
        padding-right: 40px;
    };
    @media (max-width: 768px) {
        border-radius: 0px;
    };
`;

export interface ContainerProps {
    responsiveFlexDirection?: string;
    flexDirection?: string;
    gap?: string | number;
    display?: string;
    padding?: string;
    margin?: string;
    backgroundColor?: string;
    borderBottom?: string;
    border?: string;
    alignItems?: string;
    width?: string;
    height?: string;
    marginLeft?: string;
    borderRadius?: string;
    justifyContent?: string;
    marginTop?: string;
    cursor?: string;
    paddingTop?: string;
    flexWrap?: string;
    flex?: number;
    overflow?: string;
    textOverflow?: string;
    textWrap?: string;
    paddingBottom?: string;
    paddingLeft?: string;
    paddingRight?: string;
    maxWidth?: string;
    minHeight?: string;
    maxHeight?: string;
    transform?: string;
    flexFlow?: string;
    overflowWrap?: string;
}

export const Container = styled.div<ContainerProps>`
  gap: ${({ gap }) => typeof gap === 'number' ? `${gap}px` : gap || "0px"};
  cursor: ${({ cursor }) => cursor || 'inherit'};
  flex-direction: ${({ flexDirection }) => flexDirection};
  display: ${({ display }) => display};
  gap: ${({ gap }) => gap};
  align-items: ${({ alignItems }) => alignItems};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  margin-left: ${({ marginLeft }) => marginLeft};
  border-radius: ${({ borderRadius }) => borderRadius};
  justify-content: ${({ justifyContent }) => justifyContent};
  margin-top: ${({ marginTop }) => marginTop};
  border: ${({ border }) => border || "none"};
  border-bottom: ${({ borderBottom }) => borderBottom};
  padding-top: ${({ paddingTop }) => paddingTop};
  padding-bottom: ${({ paddingBottom }) => paddingBottom};
  padding-left: ${({ paddingLeft }) => paddingLeft};
  padding-right: ${({ paddingRight }) => paddingRight};
  height: ${({ height }) => height};
  min-height: ${({ minHeight }) => minHeight};
  max-height: ${({ maxHeight }) => maxHeight};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  flex: ${({ flex }) => flex};
  overflow: ${({ overflow }) => overflow};
  text-overflow: ${({ textOverflow }) => textOverflow};
  text-wrap: ${({ textWrap }) => textWrap};
  border-bottom: ${({ borderBottom }) => borderBottom};
  transform: ${({ transform }) => transform};
  flex-flow: ${({ flexFlow }) => flexFlow};
  overflow-wrap: ${({ overflowWrap }) => overflowWrap};
  @media (max-width: 1280px) {
    flex-direction: ${({ responsiveFlexDirection }) => responsiveFlexDirection};
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  padding: 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: white;
`;

interface MainContainerProps {
    padding?: string,
    flexDirection?: string,
    backgroundColor?: string,
    gap?: string,
    justifyContent?: string,
    borderRadius?: string,
    maxWidth?: string,
}

export const MainContainer = styled.div<MainContainerProps>`
    display: flex;
    flex-direction: ${({ flexDirection }) => flexDirection || "row"};
    padding: ${({ padding }) => padding || '0px'};
    gap: ${({ gap }) => gap || '24px'};
    justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
    border-radius: ${({ borderRadius }) => borderRadius || '0px'};
`;

const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
        color: theme.palette.common.black
    },
    tooltip: {
        backgroundColor: theme.palette.common.black,
    },
}));

export const SymphonyTooltip = ({
    className = '',
    ...props
}: any) => {
    const classes = useStylesBootstrap();

    return (
        <Tooltip
            arrow
            classes={classes}
            {...props}
            className={`symphonyTooltipComponent ${className}`}
        />
    )
}

interface StyledNavBarProps {
    justifyContent?: string;
}

export const StyledNavBar = styled.nav<StyledNavBarProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ justifyContent }: StyledNavBarProps) => justifyContent || "inherit"};
  border-bottom: 1px solid rgba(209, 213, 219, 1);
  background-color: ${Colors.PAPER_CONTAINER};
  @media (max-width: 430px) {
    gap: 8px;
    align-items: center;
    padding-top: 0px;
  }
`;

export const ChipFilterPopOver = styled.span`
  background: rgba(136, 0, 255, 0.08);
  color: #8800FF;
  padding: 4px 8px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  width: fit-content;
  margin-left: -6px;
  font-family: "DIN";
`

export const TitlePopOver = styled.div`
  font-size: 16px;
  color: black;
`

export const SelectPopOver = styled(Select)`
    font-family: "DIN";
`

export const MenuItemPopOver = styled(MenuItem)`
    font-family: "DIN";
`

export const PurpleContainer = styled.div`
  background: rgba(136, 0, 255, 0.08);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 8px;
`;

export const PlatformsIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 18px;
  min-height: 18px;
  max-width: 18px;
  max-height: 18px;
`;

export const CampaignTypeText = styled.p`
  font-size: 12px;
`;

export default Sty

const FB_PRESET_AUDIENCES: TargetingAudienceGroup[] = [
    {
        id: 'fb_engagers',
        title: 'Fans who engaged with your Page',
        tags: [
            {
                id: 1,
                title: 'Facebook',
                audience_size: 1000000,
                type: 'presetAudience'
            }
        ]
    },
    {
        id: 'ig_engagers',
        title: 'Fans who engaged with your Instagram',
        tags: [
            {
                id: 1,
                title: 'Facebook',
                audience_size: 1000000,
                type: 'presetAudience'
            }
        ]
    },
    {
        id: 'ig_engagers',
        title: 'IG Engagers',
        tags: [
            {
                id: 1,
                title: 'Facebook',
                audience_size: 1000000,
                type: 'presetAudience'
            }
        ]
    }
]